VjsAdmin.UserForm = (function () {
    const me = {};

    me.original_form = null;

    function validatePasswordLength() {
        const password = $('#password').val();
        if (password.length >= 8 && password.length <= 100) {
            $('#password').removeClass('is-invalid');
            enableSubmit();
            return true;
        }
        $('#password').addClass('is-invalid');
        disableSubmit();
        return false;
    }

    function validatePasswordMatch() {
        const password = $('#password').val();
        const passwordConfirm = $('#password_confirm').val();
        if (password === passwordConfirm) {
            $('#password_confirm').removeClass('is-invalid');
            validatePasswordLength();
            return true;
        }
        $('#password_confirm').addClass('is-invalid');
        disableSubmit();
        return false;
    }

    function disableSubmit() {
        $('input[type=submit]').prop('disabled', true).attr('title', 'Please fill out all required fields.');
    }

    function enableSubmit() {
        $('input[type=submit]').prop('disabled', false).attr('title', '');
    }

    const init = function () {
        $('#generate-password').on('click', (e) => {
            e.preventDefault();
            let newPassword = $.passGen({ length: 10 });
            newPassword = newPassword.replace(/l/g, 'L');
            newPassword = newPassword.replace(/I/g, 'i');
            newPassword = newPassword.replace(/1/g, 'X');
            newPassword = newPassword.replace(/0/g, 'Z');
            newPassword = newPassword.replace(/O/g, 'Z');
            newPassword = newPassword.replace(/o/g, 'z');
            $('#password,#password_confirm').val(newPassword).attr('type', 'text').trigger('input');
            $('#password,#password_confirm').change();
            handleEmailCredentialsCheckbox();
        });

        $('#password, #password_confirm').on('input', () => {
            validatePasswordLength();
            validatePasswordMatch();
        });

        $('#password,#password_confirm,#email').on('input', () => {
            handleEmailCredentialsCheckbox();
        });

        // save original state of form, for checking for changes
        me.original_form = $('#user-edit-form').serialize();
    };

    const handleEmailCredentialsCheckbox = function () {
        const pass1 = $('#password').val();
        const pass2 = $('#password_confirm').val();
        const email = $('#email').val();
        if (pass1 === pass2 && pass1 !== '' && email !== '') {
            $('#email_credentials').prop('disabled', false);
        } else {
            $('#email_credentials').prop('disabled', true);
        }
    };

    return {
        init,
    };
}());
